import { Box, Button, Stack, Typography } from "@mui/material";
import { FileCheck, FileUp } from "lucide-react";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { useTheme } from "styled-components";
import { useApi } from "../../contexts/ApiContext";

interface FileUploadButtonProps {
  onChange(files: File[]): void;
  accept: string;
  label: string;
  labelWhenFilesSelected?: (files: File[]) => string;
}
const FileUploadButton2 = forwardRef<HTMLButtonElement, FileUploadButtonProps>(
  ({ onChange, accept, label, labelWhenFilesSelected = () => label }, ref) => {
    const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
    const fileInputRef = React.useRef<HTMLInputElement>(null);

    const { isSubmitting, isLoading } = useApi();
    const isDisabled = isLoading || isSubmitting;

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const files = [];
      if (event.target.files?.length) {
        for (let i = 0; i < event.target.files.length; i++) {
          files.push(event.target.files[i]);
        }
      }
      setSelectedFiles(files);
    };

    useEffect(() => {
      onChange(selectedFiles);
    }, [selectedFiles]);

    const openFileDialog = () => {
      console.log("fileInputRef.current", fileInputRef.current);
      if (fileInputRef.current) {
        fileInputRef.current.click();
      }
    };

    useImperativeHandle(
      ref,
      () => {
        return fileInputRef.current as HTMLButtonElement;
      },
      []
    );

    const theme = useTheme();

    return (
      <Button
        sx={{ justifyContent: "flex-start" }}
        size="small"
        color={"uploadButton"}
        disabled={isDisabled}
        onClick={openFileDialog}
      >
        <input
          accept={accept}
          multiple
          ref={fileInputRef}
          type="file"
          hidden
          onChange={handleFileChange}
        />
        <Stack direction={"row"} gap={2} alignItems={"center"}>
          <Box
            sx={{
              display: "flex",
              padding: 1,
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "50%",
              backgroundColor: "#EDE9FE",
            }}
          >
            {selectedFiles.length ? <FileCheck /> : <FileUp />}
          </Box>
          <Stack gap={0.2} textAlign={"left"}>
            <Box>
              <Typography variant="report.card.info.title">
                {selectedFiles.length
                  ? labelWhenFilesSelected(selectedFiles)
                  : label}
              </Typography>
            </Box>
          </Stack>
        </Stack>
      </Button>
    );
  }
);

export default FileUploadButton2;
